module.exports = __webpack_public_path__ + "img/dtx-banner-1.32b52862.png";